/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JsonNode } from '../models/JsonNode';
import type { ResetPasswordForm } from '../models/ResetPasswordForm';
import type { ResetPasswordInfo } from '../models/ResetPasswordInfo';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PasswordResetRestControllerService {
    /**
     * @returns ResetPasswordInfo OK
     * @throws ApiError
     */
    public static checkPasswordResetToken({
        token,
    }: {
        token: string,
    }): CancelablePromise<ResetPasswordInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/auth/password',
            query: {
                'token': token,
            },
        });
    }
    /**
     * @returns JsonNode OK
     * @throws ApiError
     */
    public static resetPassword({
        requestBody,
    }: {
        requestBody: ResetPasswordForm,
    }): CancelablePromise<JsonNode> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/auth/password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
